import React, { useEffect, useState, useRef } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import styles from '../assets/styles/Mail.module.scss';

const VerifyEmail: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');

  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [message, setMessage] = useState('メールアドレスを確認しています...');

  // 重複実行を防止するためのフラグ
  const hasFetched = useRef(false);

  useEffect(() => {
    // すでにリクエスト済み、またはトークンがない場合は実行しない
    if (hasFetched.current) return;
    const verifyToken = async () => {
      if (!token) {
        setStatus('error');
        setMessage('トークンが不足しています。');
        return;
      }
      // リクエスト開始をマーク
      hasFetched.current = true;
      try {
        const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/auth/verify-email?token=${token}`);
        const data = await res.json();
        if (res.ok) {
          setStatus('success');
          setMessage('仮会員登録のメール認証が完了しました！\n運営の承認が完了するまで今しばらくお待ちください。');
        } else {
          setStatus('error');
          setStatus((prev) => (prev === 'success' ? 'success' : 'error'));
          setMessage(data.detail || '認証に失敗しました。');
        }
      } catch (error) {
        setStatus('error');
        setMessage('サーバーとの通信に失敗しました。');
      }
    };

    verifyToken();
  }, [token]);
  const getButtonProps = () => {
    if (status === 'loading') {
      return {
        label: '認証中...',
        disabled: true,
        onClick: () => { },
      };
    }
    if (status === 'success') {
      return {
        label: 'ログイン画面へ',
        disabled: false,
        onClick: () => navigate('/login'),
      };
    }
    // error
    return {
      label: '再度新規登録へ',
      disabled: false,
      onClick: () => navigate('/pre-register'),
    };
  };
  const buttonProps = getButtonProps();

  return (
    <div className={styles.containerWrap}>
      <div className={styles.backgroundGlow}>
        <div className={styles.glowBlue} />
        <div className={styles.glowPink} />
      </div>
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.contentInner}>
            <div className={styles.resultCard}>
              <img src="/images/logo_aibex_line_b.svg" alt="AI-BEX" className={styles.logo} />

              <h1>
                {status === 'loading' && '認証中...'}
                {status === 'success' && '認証完了'}
                {status === 'error' && '認証失敗'}
              </h1>
              <p className={`${styles.description} ${status === 'error' ? styles.error : ''}`} >
                {message}
              </p>
              <button
                onClick={buttonProps.onClick}
                disabled={buttonProps.disabled}
                style={{
                  opacity: buttonProps.disabled ? 0.6 : 1,
                  cursor: buttonProps.disabled ? 'not-allowed' : 'pointer',
                }}
              >
                {buttonProps.label}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div >
  );
};

export default VerifyEmail;